import { _assert } from '@naturalcycles/js-lib';
import { countryData } from './countryData.js';
class CountrySharedUtil {
  getAllCountryData() {
    return countryData;
  }
  requireCountryData(code) {
    const cd = countryData[code];
    _assert(cd, `CountryData not found for: ${code}`);
    return cd;
  }
  getCountryData(code) {
    return countryData[code] || null;
  }
}
export const countrySharedUtil = new CountrySharedUtil();